// Taken from myaccountsite. TODO: Move to dustin-microsite
import { useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'

type ExportDataType = {
  data: any
  headers?: any
  done?: any
}

type ExportCsvProps = {
  onClick: () => ExportDataType
  filename: string
  children: React.ReactNode
}

const defaultValue = {
  data: [],
  headers: [],
  done: null,
}

const ExportCsv = ({ onClick, filename, children }: ExportCsvProps) => {
  const [exportData, handleExportData] = useState<ExportDataType>(defaultValue)
  const [downloading, handleDownloading] = useState(false)
  const [isBrowser, setIsBrowser] = useState(false)

  useEffect(() => {
    setIsBrowser(true)
  }, [])

  const csvLinkOnClick = (_: any, done: any) => {
    const d = onClick()
    d.done = done

    handleExportData(d)
    handleDownloading(true)
  }

  // ie11 fix (asyncOnClick does not work)
  useEffect(() => {
    if (downloading) {
      exportData.done()

      handleDownloading(false)
    }
  }, [exportData, downloading])

  return (
    <div className="d-none d-lg-block d-xl-block">
      {/* Temporary fix for Next 13 links */}
      {isBrowser && (
        <CSVLink
          className="d-flex align-items-center"
          style={{ textDecoration: 'none' }}
          data={exportData.data}
          headers={exportData.headers}
          filename={filename}
          asyncOnClick={true}
          separator=";"
          onClick={csvLinkOnClick}>
          {children}
        </CSVLink>
      )}
    </div>
  )
}

export default ExportCsv
